import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { PershingError, ServiceRouter, LogService } from '@pershing/pershing-core';
import { NxiConfigUtil } from '@pershing/nxi-common';
import UrlContentMapping from '../static/url-content-mapping';

@Injectable()
export class DisclosureContentService {
    error$: Observable<PershingError>;
    private _communityName: string;
    private _error: BehaviorSubject<PershingError>;
    private dataStore: {
        urlContentMapping: any
    };

    constructor(private serviceRouter: ServiceRouter, private logService: LogService, private http: HttpClient,
                @Optional() private router: Router, @Optional() @Inject('AppSettings') private appSettings: any) {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._communityName = NxiConfigUtil.getCommunityName(this.appSettings);
        console.log('communityName from disclosure service' + this._communityName);
        this.dataStore = { urlContentMapping: null };
        this.dataStore.urlContentMapping = UrlContentMapping;
    }

    getCommunityName(): string {
        return this._communityName;
    }

    getArticleIdForCurrentPage(): string {
        let articleId: string;
        let currentPage: string;
        let parentPage: string;
        let routeArray = this.router.url.split('/');
        if (routeArray[routeArray.length - 1].split('?').length > 1) {
            routeArray[routeArray.length - 1] = routeArray[routeArray.length - 1].split('?')[0];
        } else if (routeArray[routeArray.length - 1].split('#').length > 1) {
            routeArray[routeArray.length - 1] = routeArray[routeArray.length - 1].split('#')[0];
        } else if (routeArray[routeArray.length - 1].split(';').length > 1) {
            routeArray[routeArray.length - 1] = routeArray[routeArray.length - 1].split(';')[0];
        }
        if (routeArray.length < 3) {
            // error message
            // throw new Error('Invalid route');
            return articleId;
        } else if (routeArray.length === 5 && routeArray[2] === 'disclosure') {
            parentPage = routeArray[3];
            currentPage = routeArray[4];
            articleId = this.dataStore.urlContentMapping[parentPage][currentPage];
        } else {
            currentPage = routeArray[routeArray.length - 1];
            articleId = this.dataStore.urlContentMapping[currentPage];
        }
        console.log('routeArray from disclosure service' + routeArray);
        console.log('articleId from disclosure service' + articleId);
        return articleId;
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'contentService', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
